import React from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import About from "./about";
import BlogGrid from "./blog/bloggrid";
import BlogList from "./blog/bloglist";
import BlogSingle from "./blog/blogsingle";
import BlogStandard from "./blog/blogstandard";
import Contact from "./contact/contactus";
import ContactusOption from "./contact/contactusoption";
import HomeFive from "./home/homeFive";
import HomeFour from "./home/homeFour";
import HomeOne from "./home/homeOne";
import ModernHome from "./home/homeModern"; // NEW: Ultra-modern homepage
import HomeSix from "./home/homeSix";
import HomeThree from "./home/homeThree";
import HomeTwo from "./home/homeTwo";
import NotFound from "./pages/notfound";
import Pricing from "./pages/pricing";
import RequestQuote from "./pages/requestquote";
import ShortCodes from "./pages/shortcodes";
import Typography from "./pages/typography";
import ProjectGrid from "./projects/projectgrid";
import ProjectMasonary from "./projects/projectmasonary";
import ProjectSingle from "./projects/projectsingle";
import RSE from "./rse";
import ServiceDebours from "./services/servicedebours";
import ServiceDouane from "./services/servicedouane";
import ServicePetrolier from "./services/servicepetrolier";
import ServicePrestations from "./services/serviceprestations";
import Services from "./services/services";
import ServiceTransport from "./services/servicetransport";

function MainNavigation() {
  return (
    <Router>
      <Routes>
        {/** Home */}
        <Route path="/" element={<HomeOne />} />
        <Route path="/home-one" exact={true} element={<HomeOne />} />
        <Route path="/home-two" exact={true} element={<HomeTwo />} />
        <Route path="/home-three" exact={true} element={<HomeThree />} />
        <Route path="/home-four" exact={true} element={<HomeFour />} />
        <Route path="/home-five" exact={true} element={<HomeFive />} />
        <Route path="/home-six" exact={true} element={<HomeSix />} />
        {/** Pages */}
        <Route path="/notfound" exact={true} element={<NotFound />} />
        <Route path="/pricing" exact={true} element={<Pricing />} />
        <Route path="/requestquote" exact={true} element={<RequestQuote />} />
        <Route path="/shortcodes" exact={true} element={<ShortCodes />} />
        <Route path="/typography" exact={true} element={<Typography />} />
        {/** About Services Contact */}
        <Route path="/about" exact={true} element={<About />} />
        <Route path="/rse" exact={true} element={<RSE />} />
        <Route path="/services" exact={true} element={<Services />} />
        <Route
          path="/servicedebours"
          exact={true}
          element={<ServiceDebours />}
        />
        <Route
          path="/serviceprestations"
          exact={true}
          element={<ServicePrestations />}
        />
        <Route path="/servicedouane" exact={true} element={<ServiceDouane />} />
        <Route
          path="/servicetransport"
          exact={true}
          element={<ServiceTransport />}
        />
        <Route
          path="/servicepetrolier"
          exact={true}
          element={<ServicePetrolier />}
        />
        <Route path="/contact" exact={true} element={<Contact />} />
        <Route
          path="/contactusoption"
          exact={true}
          element={<ContactusOption />}
        />
        {/** Blog */}
        <Route path="/bloggrid" exact={true} element={<BlogGrid />} />
        <Route path="/bloglist" exact={true} element={<BlogList />} />
        <Route path="/blogsingle" exact={true} element={<BlogSingle />} />
        <Route path="/blogstandard" exact={true} element={<BlogStandard />} />
        {/** Projects */}
        <Route path="/projectgrid" exact={true} element={<ProjectGrid />} />
        <Route
          path="/projectmasonary"
          exact={true}
          element={<ProjectMasonary />}
        />
        <Route path="/projectsingle" exact={true} element={<ProjectSingle />} />
        {/** invalid routes redirection */}
        <Route element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default MainNavigation;
